module.exports = __webpack_public_path__ + "static/overlays-8190bd849571d99d1511f3cb9969653c.png";